import { HttpClient } from '../../httpClient'
import { OpalApiRequestBody, OpalApiResponseDocument } from '../../schema'

export function createBoardObjectCollection(
  requestBody: OpalApiRequestBody<'CreateBoardObjectCollectionV3'>
): Promise<OpalApiResponseDocument<'CreateBoardObjectCollectionV3', 201>> {
  const url = new URL('/board_object_collections/v3', window.location.origin)

  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
